<template>
  <div class="card border-0 p-4 mb-3 mt-0" data-cy="review-card">
    <!--HEADER -->
    <div class="row mb-3">
      <div v-if="!onlyOneDepartment" class="col-sm-4 text-right">
        <img
          v-if="platform[review.reviewOutlet]"
          :src="platform[review.reviewOutlet]"
          class="logo"
          alt="default logo"
        />
        <div class="font-weight-bold text-uppercase small" v-if="review.department">
          {{ $t(`message.reviews.${review.department}`) }}
        </div>
      </div>
      <div class="col-sm-8 order-first-sm">
        <div class="media">
          <div class="reviewer-avatar mr-3">
            <img
              class="reviewer-avatar-img"
              v-if="review.photoUrl"
              :src="review.photoUrl"
              :alt="review.reviewerFullName"
            />
            <MobialisAvatar v-else :fullName="review.reviewerFullName" />
          </div>
          <div class="media-body">
            <div class="reviewer-name text-muted small">{{ review.reviewerFullName }}</div>
            <div>
              <MobialisStarBar
                :stacked="false"
                :spacing="1"
                :showCount="false"
                :aggregateRating="parseFloat(review.rating)"
              ></MobialisStarBar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- REVIEW -->
    <div>
      <p v-if="review.title" class="mt-0">
        <b>{{ review.title }}</b>
      </p>
      <mobialis-truncate-text
        v-if="review.discussion"
        class="mb-2 mt-0 p"
        :value="review.discussion"
        :buttonLabelMore="$t('message.reviews.more')"
        :buttonLabelLess="$t('message.reviews.less')"
        :minTeaser="minTeaser"
        :maxTeaser="maxTeaser"
      >
      </mobialis-truncate-text>
      <div class="review-date text-muted">
        {{ $t('message.reviews.reviewedOn') }} {{ review.publishedAt | reviewDate }}
      </div>
    </div>
    <!-- RESPONSES -->
    <!-- GMB reviews -->
    <div v-if="review.response" class="response mt-4">
      <div class="py-1 pl-3">
        <mobialis-truncate-text
          class="mb-2 mt-0 p"
          :value="review.response.message"
          :buttonLabelMore="$t('message.reviews.more')"
          :buttonLabelLess="$t('message.reviews.less')"
          :minTeaser="minTeaser"
          :maxTeaser="maxTeaser"
        >
        </mobialis-truncate-text>
        <div class="review-date text-muted">
          {{ business }} {{ $t('message.reviews.respondedOn') }} {{ review.response.publishedAt | reviewDate }}
        </div>
      </div>
    </div>
    <!-- non-GMB reviews -->
    <div v-else-if="review.hasResponse" class="response mt-4">
      <div v-for="(response, indexA) in dedupedResponses" :key="indexA" class="py-1 pl-3">
        <mobialis-truncate-text
          class="mb-2 mt-0 p"
          :value="response.message"
          :buttonLabelMore="$t('message.reviews.more')"
          :buttonLabelLess="$t('message.reviews.less')"
          :minTeaser="minTeaser"
          :maxTeaser="maxTeaser"
        >
        </mobialis-truncate-text>
        <div class="review-date text-muted">
          {{ business }} {{ $t('message.reviews.respondedOn') }} {{ response.publishedAt | reviewDate }}
        </div>

        <!-- Related Staff -->
        <template v-if="review.staff.length > 0">
          <template v-for="(staff, indexB) in review.staff">
            <div :key="indexB" class="mt-3">
              <p class="mb-0 mt-4">
                <b>{{ $t('message.reviews.relatedStaff') }}</b>
              </p>
              <div class="staff-card pt-2 d-flex">
                <div class="staff-avatar">
                  <MobialisAvatar
                    class="mr-3"
                    :fullName="review.staff[indexB].name"
                    :avatarImgSrc="review.staff[indexB].profilePhotoUrl"
                  />
                </div>
                <div class="reviewer-details">
                  <div class="reviewer-name small text-muted">{{ review.staff[indexB].name }}</div>
                  <div class="reviewer-job small text-muted">{{ review.staff[indexB].jobTitle }}</div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import moment from 'moment';

const google = require('../../assets/Google.svg');
const facebook = require('../../assets/Facebook.svg');
const avr = require('../../assets/av-icon-black.svg');

export default {
  name: 'ReviewCard',
  data() {
    return {
      platform: [null, google, facebook, avr],
    };
  },
  props: {
    review: {
      type: Object,
      required: false,
    },
    business: {
      type: String,
      required: false,
    },
    minTeaser: {
      type: Number,
      required: false,
    },
    maxTeaser: {
      type: Number,
      required: false,
    },
    onlyOneDepartment: {
      type: Boolean,
      default: false,
    },
  },
  beforeCreate() {
    if (this.$store.state.user.language === 'fr_CA') {
      moment.locale('fr-ca');
    }
  },
  filters: {
    reviewDate(value) {
      return moment(value).format('LL');
    },
  },
  computed: {
    dedupedResponses() {
      return uniqBy(this.review.responses, 'message');
    },
  },
};
</script>

<style scoped lang="scss">
img.logo {
  width: 32px;
}
img.reviewer-avatar-img {
  width: 40px;
}
.review {
  display: inline;
}
.review-date {
  font-size: 12px;
  line-height: 14px;
}
.response {
  border-left: 4px solid #f0f4f7;
}
.reviewer-avatar {
  margin-top: 3px;
}
@media (min-width: 576px) {
  .order-first-sm {
    -ms-flex-order: -1;
    order: -1;
  }
}
</style>
